import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createBlock(_component_VueDatePicker, {
    utc: "preserve",
    timezone: "Europe/Moscow",
    locale: _ctx.$i18n.locale,
    class: "q-py-sm param-date",
    style: 'width: 150px; min-width: 150px; max-width: 150px;',
    teleport: true,
    modelValue: _ctx.theModel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel) = $event)),
    "enable-time-picker": false,
    disabled: !_ctx.editable,
    clearable: false,
    required: true,
    format: _ctx.formatDate,
    "text-input": _ctx.textInputOptions
  }, null, 8, ["locale", "modelValue", "disabled", "format", "text-input"]))
}